// PWA: Service Worker Registration + Push Notifications
const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    console.log('[PWA] Service Worker registered');
    return registration;
  } catch (error) {
    console.error('[PWA] SW registration failed:', error);
    return null;
  }
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';

  const permission = await Notification.requestPermission();
  return permission;
}

export async function subscribeToPush(registration) {
  if (!registration) return null;

  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(
        // VAPID public key - generated for AgrarKapital
        'BDummyKeyForNow_ReplaceWithRealVAPIDKey_WhenPushServerIsSetUp_64chars'
      )
    });
    return subscription;
  } catch (error) {
    console.log('[PWA] Push subscription failed (expected without VAPID server):', error.message);
    return null;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Local notification fallback (works without push server)
export function showLocalNotification(title, body, url = '/admin') {
  if (Notification.permission !== 'granted') return;

  const notification = new Notification(title, {
    body,
    icon: '/favicon-96x96.png',
    badge: '/favicon-96x96.png',
    tag: 'agrarkapital-' + Date.now(),
    vibrate: [200, 100, 200]
  });

  notification.onclick = () => {
    window.focus();
    if (url) window.location.href = url;
    notification.close();
  };
}

// Poll for new leads and notify
let lastLeadCount = null;

export async function checkForNewLeads(token) {
  if (!token || Notification.permission !== 'granted') return;

  try {
    const response = await fetch(`${API_URL}/api/admin/queue-statistics`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) return;

    const stats = await response.json();
    const currentCount = stats.gesamt_offen || 0;

    if (lastLeadCount !== null && currentCount > lastLeadCount) {
      const diff = currentCount - lastLeadCount;
      showLocalNotification(
        `${diff} neue Bewertungsanfrage${diff > 1 ? 'n' : ''}`,
        `${currentCount} offene Anfragen insgesamt. ${stats.prio_1_dringend?.offen || 0} davon DRINGEND.`,
        '/admin?tab=bewertungen'
      );
    }

    lastLeadCount = currentCount;
  } catch (error) {
    // Silently fail
  }
}
